import { TsrctDemandStatus } from '@/generated/gql/graphql';

export const isDemandEditable = (data?: {
  tesseract: {
    demand: {
      status: TsrctDemandStatus;
    };
  };
}) =>
  data?.tesseract.demand.status === TsrctDemandStatus.INITIALIZED ||
  data?.tesseract.demand.status === TsrctDemandStatus.OPEN;
